<template>
  <div>
    <div class="nk-app-root">
      <div class="nk-main">
        <div class="nk-wrap">
          <Header v-show="!loading_page" />
          <div class="nk-content">
            <div class="container wide-xl">
              <div class="nk-content-inner">
                <Navigation v-show="!loading_page" />
                <div class="nk-content-body" v-show="!loading_page">
                  <div class="nk-content-wrap">
                    <div class="nk-block nk-block-lg">
                      <div class="nk-block-head">
                        <div class="nk-block-head-content d-flex justify-content-between align-items-center">
                          <h4 class="nk-block-title">{{ $t('dm_preislisten_title') }}</h4>
                          <button v-if="canDmEdit" class="btn btn-sm btn-primary" @click="openModal(null)">
                            <em class="icon ni ni-plus"></em> {{ $t('dm_preislisten_btn_new') }}
                          </button>
                        </div>
                      </div>

                      <div class="form-control-wrap mb-3">
                        <input type="text" class="form-control" :placeholder="$t('dm_common_quick_filter')" v-model="quickFilterText" />
                      </div>

                      <div class="card card-bordered">
                        <div class="dm-table-wrap">
                          <table class="dm-table">
                            <thead>
                              <tr>
                                <th v-for="col in tableColumns" :key="col.field" @click="toggleSort(col.field)" class="dm-table-th">
                                  {{ col.label }}
                                  <span v-if="sortField === col.field" class="dm-sort-icon">{{ sortAsc ? '&#9650;' : '&#9660;' }}</span>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="row in filteredData" :key="row._id" @click="onRowClicked(row)" class="dm-table-row">
                                <td v-for="col in tableColumns" :key="col.field">{{ getCellValue(row, col) }}</td>
                              </tr>
                              <tr v-if="filteredData.length === 0">
                                <td :colspan="tableColumns.length" class="text-center text-muted py-4">{{ $t('dm_common_no_entries_found') }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal fade" tabindex="-1" id="modalPreisliste">
                    <div class="modal-dialog modal-lg" role="document">
                      <div class="modal-content">
                        <a href="#" class="close" data-dismiss="modal" aria-label="Close">
                          <em class="icon ni ni-cross"></em>
                        </a>
                        <div class="modal-header">
                          <h5 class="modal-title">{{ preislisteEntry._id ? $t('dm_preislisten_modal_edit') : $t('dm_preislisten_modal_new') }}</h5>
                        </div>
                        <div class="modal-body">
                          <div class="alert alert-danger" v-if="errorMessage">{{ errorMessage }}</div>
                          <div class="row gy-4">
                            <div class="col-sm-6">
                              <div class="form-group">
                                <label class="form-label">{{ $t('dm_common_col_name') }}</label>
                                <input type="text" class="form-control" v-model="preislisteEntry.name" :disabled="preislisteEntry.freigegeben" />
                              </div>
                            </div>
                            <div class="col-sm-3">
                              <div class="form-group">
                                <label class="form-label">{{ $t('dm_preislisten_label_valid_from') }}</label>
                                <input type="date" class="form-control" v-model="preislisteEntry.gueltig_ab" :disabled="preislisteEntry.freigegeben" />
                              </div>
                            </div>
                            <div class="col-sm-3">
                              <div class="form-group">
                                <label class="form-label">{{ $t('dm_preislisten_label_valid_to') }}</label>
                                <input type="date" class="form-control" v-model="preislisteEntry.gueltig_bis" :disabled="preislisteEntry.freigegeben" />
                              </div>
                            </div>
                          </div>

                          <hr class="preview-hr" />
                          <h6 class="overline-title overline-title-alt mb-3">{{ $t('dm_preislisten_section_positions') }}</h6>
                          <div v-for="(pos, idx) in preislisteEntry.positionen" :key="idx" class="card card-bordered mb-2">
                            <div class="card-inner py-3">
                              <div class="d-flex justify-content-between align-items-start mb-2">
                                <span class="text-muted small">{{ $t('dm_preislisten_label_position') }} {{ idx + 1 }}</span>
                                <button v-if="!preislisteEntry.freigegeben" class="btn btn-sm btn-outline-danger btn-icon" @click="removePosition(idx)">
                                  <em class="icon ni ni-trash"></em>
                                </button>
                              </div>
                              <div class="row gy-3">
                                <div class="col-sm-6">
                                  <div class="form-group">
                                    <label class="form-label">{{ $t('dm_common_col_designation') }}</label>
                                    <input type="text" class="form-control form-control-sm" v-model="pos.bezeichnung" :disabled="preislisteEntry.freigegeben" />
                                  </div>
                                </div>
                                <div class="col-sm-3">
                                  <div class="form-group">
                                    <label class="form-label">{{ $t('dm_common_col_system_type') }}</label>
                                    <select class="form-control form-control-sm" v-model="pos.anlage_typ" :disabled="preislisteEntry.freigegeben">
                                      <option value="">{{ $t('dm_common_all') }}</option>
                                      <option value="WEA">WEA</option>
                                      <option value="PV">PV</option>
                                      <option value="BAT">BAT</option>
                                    </select>
                                  </div>
                                </div>
                                <div class="col-sm-3">
                                  <div class="form-group">
                                    <label class="form-label">{{ $t('dm_preislisten_label_inspection_type') }}</label>
                                    <select class="form-control form-control-sm" v-model="pos.pruefungs_typ" :disabled="preislisteEntry.freigegeben">
                                      <option value="">{{ $t('dm_preislisten_no_type') }}</option>
                                      <option v-for="opt in inspectionTypeOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div class="row gy-3 mt-1">
                                <div class="col-sm-3">
                                  <div class="form-group">
                                    <label class="form-label">{{ $t('dm_preislisten_label_price_eur') }}</label>
                                    <input type="number" step="0.01" class="form-control form-control-sm" v-model="pos.preis" :disabled="preislisteEntry.freigegeben" />
                                  </div>
                                </div>
                                <div class="col-sm-3">
                                  <div class="form-group">
                                    <label class="form-label">{{ $t('dm_common_col_unit') }}</label>
                                    <input type="text" class="form-control form-control-sm" v-model="pos.einheit" :disabled="preislisteEntry.freigegeben" />
                                  </div>
                                </div>
                                <div class="col-sm-6 d-flex align-items-end">
                                  <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" :id="'autoPreis_' + idx" v-model="pos.inspect_preis_automatisch" :disabled="preislisteEntry.freigegeben" />
                                    <label class="custom-control-label" :for="'autoPreis_' + idx">{{ $t('dm_preislisten_label_auto_adopt') }}</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <button v-if="!preislisteEntry.freigegeben" class="btn btn-sm btn-outline-secondary" @click="addPosition">
                            <em class="icon ni ni-plus"></em> {{ $t('dm_preislisten_btn_add_position') }}
                          </button>

                          <div class="form-group mt-4" v-if="!preislisteEntry.freigegeben">
                            <button type="button" class="btn btn-primary" @click="savePreisliste">
                              {{ preislisteEntry._id ? $t('dm_common_btn_update') : $t('dm_common_btn_create') }}
                            </button>
                            <button v-if="preislisteEntry._id && dmBerechtigungen.preisliste_bearbeiten" type="button" class="btn btn-outline-primary ml-2" @click="freigebenAction">
                              {{ $t('dm_preislisten_btn_release') }}
                            </button>
                          </div>
                          <div v-if="preislisteEntry.freigegeben" class="alert alert-info mt-3">
                            {{ $t('dm_preislisten_msg_released') }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <Footer />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../../components/Header.vue";
import Navigation from "../../../components/Navigation.vue";
import Footer from "../../../components/Footer.vue";
import dmTableMixin from "@/mixins/dm-table-mixin";
import dmPermissionsMixin from "@/mixins/dm-permissions-mixin";
import { getPreislisteList, getPreisliste, createPreisliste, updatePreisliste, freigebenPreisliste } from "@/services/dm.service";

export default {
  name: "DmPreislisten",
  components: { Header, Navigation, Footer },
  mixins: [dmTableMixin, dmPermissionsMixin],
  data() {
    return {
      fullLoader: null,
      preislisten: [],
      preislisteEntry: { positionen: [] },
      errorMessage: "",
    };
  },
  computed: {
    loading_page() {
      return this.$store.state.loading_page && this.$store.state.loading_page == "setup";
    },
    tableColumns() {
      var self = this;
      return [
        { label: this.$t('dm_common_col_name'), field: "name" },
        { label: this.$t('dm_preislisten_col_valid_from'), field: "gueltig_ab", formatter: function(val) { return val ? new Date(val).toLocaleDateString("de-DE") : ""; } },
        { label: this.$t('dm_preislisten_col_valid_to'), field: "gueltig_bis", formatter: function(val) { return val ? new Date(val).toLocaleDateString("de-DE") : ""; } },
        { label: this.$t('dm_preislisten_col_positions'), field: "positionen", formatter: function(val) { return val ? val.length : 0; } },
        { label: this.$t('dm_common_col_status'), field: "freigegeben", formatter: function(val) { return val ? self.$t('dm_preislisten_status_released') : self.$t('dm_preislisten_status_draft'); } },
      ];
    },
    inspectionTypeOptions() {
      return [
        { value: "WKP_M", label: this.$t('dm_anlage_inspection_type_wkp_m') },
        { value: "WKP_RB", label: this.$t('dm_anlage_inspection_type_wkp_rb') },
        { value: "WKP_E", label: "WKP_E" },
        { value: "BPW", label: this.$t('dm_anlage_inspection_type_bpw') },
      ];
    },
    filteredData() {
      return this.filterAndSort(this.preislisten, this.tableColumns);
    },
  },
  created() {
    this.loadPreislisten();
  },
  methods: {
    loadPreislisten() {
      this.showLoader();
      getPreislisteList()
        .then((d) => {
          this.hideLoader();
          if (d.data && d.data.list) this.preislisten = d.data.list;
        })
        .catch((e) => {
          this.hideLoader();
          this.$store.dispatch("api_error", e);
        });
    },
    onRowClicked(row) {
      if (row) {
        this.openModal(row);
      }
    },
    openModal(preisliste) {
      this.errorMessage = "";
      if (preisliste && preisliste._id) {
        this.showLoader();
        getPreisliste(preisliste._id).then((d) => {
          this.hideLoader();
          if (d.data && d.data.preisliste) {
            var entry = d.data.preisliste;
            if (entry.gueltig_ab) entry.gueltig_ab = entry.gueltig_ab.substring(0, 10);
            if (entry.gueltig_bis) entry.gueltig_bis = entry.gueltig_bis.substring(0, 10);
            if (!entry.positionen) entry.positionen = [];
            this.preislisteEntry = entry;
          }
          $("#modalPreisliste").modal("show");
        });
      } else {
        this.preislisteEntry = { positionen: [] };
        $("#modalPreisliste").modal("show");
      }
    },
    addPosition() {
      this.preislisteEntry.positionen.push({ bezeichnung: "", einheit: "", preis: 0, anlage_typ: "", pruefungs_typ: "", inspect_preis_automatisch: false });
    },
    removePosition(idx) {
      this.preislisteEntry.positionen.splice(idx, 1);
    },
    savePreisliste() {
      this.errorMessage = "";
      if (!this.preislisteEntry.name) {
        this.errorMessage = this.$t('dm_preislisten_error_name_required');
        return;
      }
      if (this.preislisteEntry._id) {
        updatePreisliste(this.preislisteEntry._id, this.preislisteEntry).then((d) => {
          var err = this.getApiError(d); if (err) { this.errorMessage = err; }
          else { $("#modalPreisliste").modal("hide"); this.loadPreislisten(); }
        });
      } else {
        createPreisliste(this.preislisteEntry).then((d) => {
          var err = this.getApiError(d); if (err) { this.errorMessage = err; }
          else { $("#modalPreisliste").modal("hide"); this.loadPreislisten(); }
        });
      }
    },
    freigebenAction() {
      this.$swal({
        title: this.$t('dm_preislisten_confirm_release_title'),
        text: this.$t('dm_preislisten_confirm_release_text'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t('dm_preislisten_btn_release_yes'),
        cancelButtonText: this.$t('dm_common_btn_cancel'),
      }).then((result) => {
        if (result.isConfirmed) {
          freigebenPreisliste(this.preislisteEntry._id).then(() => {
            $("#modalPreisliste").modal("hide");
            this.loadPreislisten();
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.dm-table-wrap {
  max-height: calc(100vh - 220px);
  overflow: auto;
}

.dm-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 15px;
  table-layout: fixed;
}

.dm-table th,
.dm-table td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dm-table thead {
  background: #f8f9fa;
  border-bottom: 2px solid #e2e8f0;
  position: sticky;
  top: 0;
  z-index: 1;
}

.dm-table-th {
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #64748b;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}

.dm-table-th:hover {
  color: #334155;
}

.dm-sort-icon {
  font-size: 10px;
  margin-left: 4px;
  color: #E8751A;
}

.dm-table tbody td {
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
  color: #334155;
}

.dm-table-row {
  cursor: pointer;
  transition: background 0.15s;
}

.dm-table-row:hover {
  background: #f8fafc;
}
</style>
